import data from "../../../../../src/Autocomplete/Autocomplete.docs.json";
import { Autocomplete } from '@primer/react';
import * as React from 'react';
export default {
  data,
  Autocomplete,
  React
};